import * as PIXI from 'pixi.js'
import Tool from './tool.class'
import { clear } from '../utils'

export default class DrawShieldManually extends Tool {
  drawing = false
  start
  idxs = []
  shiftKey = false
  update(event, config, container, pixiObj, options, vm) {
    super.update(...arguments)
  }
  mouseDown(event) {
    this.start = event
    this.drawing = true
  }
  mouseUp(event) {
    if (this.drawing) {
      this.drawing = false
      this.sendResultData(event)
    }
  }
  mouseWheel(event) {}
  mouseMove(event) {
    this.shiftKey = event.shiftKey
    this.drawing &&
      this.draw(
        this.start.offsetX,
        this.start.offsetY,
        event.offsetX,
        event.offsetY,
      )
  }
  mouseLeave(event) {
    if (this.drawing) {
      this.drawing = false
      this.sendResultData(event)
    }
  }
  sendResultData(endEvent) {
    this.$msg({
      type: 'DRAW_SHIELD_MANUALLY',
      delete: this.shiftKey,
      idxs: this.idxs,
    })
    clear(this.container)
  }
  draw(x1, y1, x2, y2) {
    clear(this.container)
    const options = this.options
    const rootOptions = options.rootOptions

    const cols = 120
    const rows = 32
    const box = rootOptions.box
    const blockWidth = (rootOptions.width - box.left - box.right) / cols
    const blockHeight = (rootOptions.height - box.top - box.bottom) / rows

    const particleContainer = new PIXI.ParticleContainer(cols * rows)
    this.container.addChild(particleContainer)

    const graphic = new PIXI.Graphics()
    if (this.shiftKey) {
      graphic.beginFill(0xbcbcbc, 0.3)
      graphic.lineStyle(1, 0xbcbcbc, 1)
    } else {
      graphic.beginFill(0x84bf96, 0.3)
      graphic.lineStyle(1, 0x84bf96, 1)
    }
    graphic.drawRect(0, 0, blockWidth, blockHeight)
    const texture = this.pixiObj.renderer.generateTexture(graphic)

    const offsetTop = (box.top / rootOptions.height) * options.height
    const offsetBottom = (box.top / rootOptions.height) * options.height
    this.idxs = this.getDrawAreaIdxs(
      x1,
      y1 - offsetTop,
      x2,
      y2 - offsetTop,
      cols,
      rows,
      options.width,
      options.height - offsetTop - offsetBottom,
    )
    this.idxs.forEach(i => {
      const row = Math.floor(i / cols)
      const col = i % cols
      const x = col * blockWidth
      const y = row * blockHeight + (Number(box.top) || 0)

      const rectangle = new PIXI.Sprite(texture)
      rectangle.x = x
      rectangle.y = y

      particleContainer.addChild(rectangle)
    })
  }
  getDrawAreaIdxs(x1, y1, x2, y2, cols, rows, width, height) {
    if (y1 > y2) {
      ;[y1, y2] = [y2, y1]
    }
    if (x1 > x2) {
      ;[x1, x2] = [x2, x1]
    }
    const blockWidth = width / cols
    const blockHeight = height / rows
    const startIdxX = Math.floor(x1 / blockWidth)
    const startIdxY = Math.floor(y1 / blockHeight)
    const endIdxX = Math.floor(x2 / blockWidth)
    const endIdxY = Math.floor(y2 / blockHeight)

    const result = []
    let idxX = startIdxX
    let idxY = startIdxY
    while (true) {
      result.push(idxY * cols + idxX++)
      if (idxX > endIdxX) {
        idxY++
        idxX = startIdxX
      }
      if (idxY > endIdxY) break
    }
    return result
  }
}
